import DialogMUI from './DialogMUI';

export default DialogMUI;
